<div class="home-page__search-wrap">
  <ion-icon name="search-outline"></ion-icon>
  <ion-input
    (input)="onSearch($event)"
    [placeholder]="searchPlaceholder"
    class="home-page__search"
  ></ion-input>
  <ion-icon name="options-outline" class="home-page__search-filter"></ion-icon>
</div>
